import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from "../../../services/session";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            name: '',
            payments: [],
            dates6 : [],
            dates12 : [],
            user: {
                paidMonthsInRow: 0
            },
            has6MonthLoyality: 0,
            has12MonthLoyality: 0,
            loyaltyProgramsEnabled: false,
            loyaltyPrograms: null,
            loyaltyProgramsList: [],
            maxLoyaltyProgram: 0,
        }
    },
    computed : {
        orderedPayments : function () {
            function compare(a,b) {
                if (a.paidDate < b.paidDate)
                    return 1;
                if (a.paidDate > b.paidDate)
                    return -1;
                return 0;
            }
            return this.payments.sort(compare)
        }
    },
    methods: {
        formatDate: formatDate,
        formatDate2: formatDate2,
        addPayment: addPayment,
        loyaltyStyle: loyaltyStyle,
        deletePayment: deletePayment,
        getUser: getUser,
        load: load,
        getPaymentClassTd: getPaymentClassTd,
        editPayment: editPayment,
         compare(a,b) {
            if (a.paidDate < b.paidDate)
                return 1;
            if (a.paidDate > b.paidDate)
                return -1;
            return 0;
        }
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.loyaltyProgramsEnabled = session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0;
        this.loyaltyPrograms = session.getConfig().loyaltyPrograms;
        if(session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0){
            let temp = this.loyaltyPrograms.split(";")
            this.loyaltyProgramsList = [];
            temp.forEach(t => {
                this.loyaltyProgramsList.push(parseInt(t));
            })
            this.maxLoyaltyProgram = Math.max(...this.loyaltyProgramsList);
        }
        this.load()
        this.getUser();
    }
}

function formatDate2(date) {
    return this.$moment(new Date(date)).format('DD-MM-YYYY')
}

function load() {
    let _self = this;

    AdminApiService.getPayment(this.$route.query.id)
        .then((response) => {
            _self.payments = response.data.sort((a,b) => _self.compare(a,b));
            if (_self.payments.length > 0) {
                _self.name = _self.payments[0].name + ' ' + _self.payments[0].surname;
            }
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function addPayment() {
    this.$router.push('/add-payment?id=' + this.id)
}

function deletePayment(id) {
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_payment_are_you_sure_to_delete'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deletePayment(id)
            .then((response) => {
                _self.load()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function getUser(){
    let _self = this;
    AdminApiService.getUser(this.$route.query.id)
        .then((response) => {
            _self.user = response.data;
        })
        .catch(error => {

            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}
function getPaymentClassTd(payment) {
    if(payment.paidMoney <= 0){
        return "background: red;"
    }
}

function editPayment(paymentId) {
    this.$router.push('/edit-payment?id=' + paymentId)
}

function loyaltyStyle(maxItem){
    return this.user.paidMonthsInRow >= maxItem ? 'color: green; font-size: 20px;' : 'color: red;font-size: 20px;'
}


// WEBPACK FOOTER //
// ./src/components/Users/Payment/UserPayment.js